import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { SigninComponent } from './signin/signin.component';
import { AuthenticationRoutingModule } from './authentication-routing.module';
import { LoginFormComponent } from './signin/login-form/login-form.component';
import { TwoFactorChoiceFormComponent } from './signin/twofactor-choice-form/twofactor-choice-form.component';
import { ForgotPasswordFormComponent } from './signin/forgot-password-form/forgot-password-form.component';
import { TwoFactorCodeFormComponent } from './signin/twofactor-code-form/twofactor-code-form.component';
import { TwoFactorGoogleAuthenticatorFormComponent } from './signin/twofactor-google-authenticator-form/twofactor-google-authenticator-form-component';

@NgModule({
    declarations: [
        SigninComponent,
        LoginFormComponent,
        TwoFactorChoiceFormComponent,
        ForgotPasswordFormComponent,
        TwoFactorCodeFormComponent,
        TwoFactorGoogleAuthenticatorFormComponent
    ],
    imports: [
        CommonModule,
        AuthenticationRoutingModule,
        ReactiveFormsModule,
        FormsModule
    ]
})
export class AuthenticationModule { }

